import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ServicingCommonStoreService } from '@common/services';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import { GetOrderResponseData, GetOrderResponseDataOrderType } from 'src/sdk-servicing';

@Component({
  selector: 'asw-my-booking-itinerary-pres',
  templateUrl: './my-booking-itinerary-pres.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBookingItineraryPresComponent extends SupportComponent {
  @Input() functionList!: { [key: string]: Function };

  /** 注文応答データの取得 注文の種類 */
  orderData!: GetOrderResponseData;

  private _subscriptions: Subscription = new Subscription();

  isShowFareRules: boolean = false;

  constructor(
    public change: ChangeDetectorRef,
    private _common: CommonLibService,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super(_common);
  }

  reload(): void {}

  destroy(): void {}

  /** 初期表示処理 */
  init(): void {
    /** 注文ストアサービスを取得する */
    this._subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        this.orderData = servicingCommon.getOrder ?? ({} as GetOrderResponseData);
        this.isShowFareRules =
          this.orderData?.orderType?.channelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Nh ||
          this.orderData?.orderType?.channelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Ndc;
        this.change.markForCheck();
      })
    );
  }
}
